import type { PropsWithChildren } from 'react';
import type { RootState } from '@/store/store';

import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import NavbarSidebarLayout from '@/layouts/navbar-sidebar';
import { useAppDispatch } from '@/store/hooks';
import { StatusEnum } from '@/store/common-types';

const ProtectedRoute = ({
  children,
  isFooter,
}: PropsWithChildren & { isFooter?: boolean }) => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const { meStatus, isAuthenticated } = useSelector(
    (state: RootState) => state.auth
  );

  const { status: organizationStatus, organizations } = useSelector(
    (state: RootState) => state.organization
  );

  useEffect(() => {
    if (!isAuthenticated && meStatus === StatusEnum.failed) {
      navigate('/authentication/sign-in');
    } else if (
      isAuthenticated &&
      !organizations.length &&
      meStatus === StatusEnum.succeeded &&
      organizationStatus === StatusEnum.succeeded
    )
      navigate('/my-teams');
  }, [dispatch, isAuthenticated, meStatus, organizationStatus, organizations]);

  if (!isAuthenticated) {
    return null;
  }

  return (
    <NavbarSidebarLayout isFooter={isFooter}>
      <div className="w-full px-4 pt-6">{children}</div>
    </NavbarSidebarLayout>
  );
};

export default ProtectedRoute;
